import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Standalone audit-log service — deliberately has NO dependency on
 * AuthService. Both AdminService and AuthService need to write audit logs,
 * and AuthService itself needs to be safely injectable elsewhere without
 * risking a circular dependency. Keeping this service's only dependency as
 * HttpClient means callers pass in token/userId explicitly instead.
 */
@Injectable({ providedIn: 'root' })
export class AuditLogService {
  private apiUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  saveAuditLog(
    methodName: string,
    api: string,
    description: string,
    areaTab: string,
    token: string | null,
    userId: number | null
  ): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.post<any>(
      `${this.apiUrl}/audit/save-log`,
      { methodName, api, description, areaTab, userId },
      { headers }
    );
  }

  /**
   * Fire-and-forget convenience wrapper for the common case — logs the
   * error to console if the save fails, but never throws back to the
   * caller (audit logging should never break the action it's logging).
   */
  log(
    methodName: string,
    api: string,
    description: string,
    areaTab: string,
    token: string | null,
    userId: number | null
  ): void {
    this.saveAuditLog(methodName, api, description, areaTab, token, userId).subscribe({
      error: (err) => console.error(`[audit log] ${methodName} ${api} FAILED:`, err)
    });
  }
}